import queryString from "query-string";
import { axios } from "../lib";
import * as endpoints from "./apiEndpoints";

import { isEmpty } from "lodash";

class ContractService {
  static loadContracts(filters) {
    let url = `${endpoints.BASE_URL}${endpoints.CONTRACTS}/findContracts`;
    if (filters && filters.filtered && !isEmpty(filters.filtered)) {
      const params = `&${queryString.stringify(
        { ...filters.filtered, ...filters.sorted },
        { arrayFormat: "bracket" }
      )}`;
      url = url.concat(`?${params}`);
    }

    return axios.get(url).then((response) => response.data);
  }

  static loadITMSContracts(filters) {
    let url = `${endpoints.BASE_URL}${endpoints.CONTRACTS}/findITMSContracts`;
    if (filters && filters.filtered && !isEmpty(filters.filtered)) {
      const params = `&${queryString.stringify(
        { ...filters.filtered, ...filters.sorted },
        { arrayFormat: "bracket" }
      )}`;
      url = url.concat(`?${params}`);
    }

    return axios.get(url).then((response) => response.data);
  }

  static loadITHealthScoreContract(filters) {
    let url = `${endpoints.BASE_URL}${endpoints.CONTRACTS}/findITHealthScoreContract`;
    if (filters && filters.filtered && !isEmpty(filters.filtered)) {
      const params = `&${queryString.stringify(
        { ...filters.filtered, ...filters.sorted },
        { arrayFormat: "bracket" }
      )}`;
      url = url.concat(`?${params}`);
    }

    return axios.get(url).then((response) => response.data);
  }

  static generateContractNumber() {
    const url = `${endpoints.BASE_URL}${endpoints.CONTRACTS}/count`;
    return axios.get(url);
  }

  static getContract(id) {
    const url = `${endpoints.BASE_URL}${endpoints.CONTRACTS}/${id}`;
    return axios.get(url).then((response) => response.data);
  }

  static loadContractsByCustomerId(id) {
    const url = `${endpoints.BASE_URL}${endpoints.CONTRACTS}/customer/${id}`;
    return axios.get(url).then((response) => response.data);
  }

  static createContract(contract) {
    const url = `${endpoints.BASE_URL}${endpoints.CONTRACTS}/new`;
    const body = {
      contract
    };

    return axios.post(url, body).then((response) => response.data);
  }

  static updateContract(contract) {
    const url = `${endpoints.BASE_URL}${endpoints.CONTRACTS}/${contract.id}`;
    const body = {
      contract
    };

    return axios.put(url, body).then((response) => response.data);
  }

  static updateITHealthScore(contract) {
    const url = `${endpoints.BASE_URL}${endpoints.CONTRACTS}/${contract.id}/ITHealthScore`;
    const body = {
      contract
    };

    return axios.put(url, body).then((response) => response.data);
  }

  static deleteContract(id) {
    const url = `${endpoints.BASE_URL}${endpoints.CONTRACTS}/${id}`;
    return axios.delete(url).then((response) => response.data);
  }

  static uploadFile(contract, file) {
    const formData = new FormData();
    formData.append("contractUpload", file);

    const url = `${endpoints.BASE_URL}${endpoints.CONTRACTS}/${contract.id}/upload`;

    return axios
      .post(url, formData)
      .then((response) => this.createVersion(contract, response.data))
      .then((resp) => resp.data);
  }

  static createVersion(contract, version) {
    const url = `${endpoints.BASE_URL}${endpoints.CONTRACTS}/${contract.id}/version`;
    const body = {
      version: {
        path: version.fileName
      }
    };

    return axios.post(url, body).then((response) => response.data);
  }

  static downloadVersion(contract, version) {
    const url = `${endpoints.BASE_URL}${endpoints.CONTRACTS}/${
      contract.id
    }/version/${encodeURIComponent(version.path)}`;

    return axios.get(url).then((response) => {
      // simulate DOM click for download
      const file_path = response.data.url;
      const a = document.createElement("A");
      a.href = file_path;
      a.download = file_path.substr(file_path.lastIndexOf("/") + 1);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      return response.data;
    });
  }

  static updateVersion(contract, version) {
    const url = `${endpoints.BASE_URL}${endpoints.CONTRACTS}/${contract.id}/version`;
    const body = {
      version
    };

    return axios.put(url, body).then((response) => response.data);
  }

  static deleteVersion(customer, version) {
    const url = `${endpoints.BASE_URL}${endpoints.CONTRACTS}/${customer.id}/version`;
    const body = {
      version
    };

    return axios.delete(url, body).then((response) => response.data);
  }

  static createPurchaseOrder(contract, purchaseOrder) {
    const url = `${endpoints.BASE_URL}${endpoints.CONTRACTS}/${contract._id}/purchaseOrder`;
    const body = {
      purchaseOrder
    };

    return axios.post(url, body).then((response) => response.data);
  }

  static updatePurchaseOrder(contract, purchaseOrder) {
    const url = `${endpoints.BASE_URL}${endpoints.CONTRACTS}/${contract._id}/purchaseOrder`;

    const body = { purchaseOrder };

    return axios.put(url, body).then((response) => response.data);
  }

  static deletePurchaseOrder(contract, purchaseOrder) {
    const url = `${endpoints.BASE_URL}${endpoints.CONTRACTS}/${contract._id}/purchaseOrder/delete`;

    const body = {
      purchaseOrder: purchaseOrder.id
    };

    return axios.post(url, body).then((response) => response.data);
  }

  static createNote(contract, note) {
    const url = `${endpoints.BASE_URL}${endpoints.CONTRACTS}/${contract.id}/note`;
    const body = {
      note
    };

    return axios.post(url, body).then((response) => response.data);
  }

  static updateNote(id, note) {
    const url = `${endpoints.BASE_URL}${endpoints.CONTRACTS}/${id}/note`;
    const body = {
      note
    };

    return axios.put(url, body).then((response) => response.data);
  }

  static deleteNote(id, noteId) {
    const url = `${endpoints.BASE_URL}${endpoints.CONTRACTS}/${id}/note/${noteId}`;

    return axios.delete(url).then((response) => response.data);
  }

  static updateContractStats(contract, line) {
    const url = `${endpoints.BASE_URL}${endpoints.CONTRACTS}/${contract.id}/line`;

    const body = {
      line
    };

    return axios.put(url, body).then((response) => response.data);
  }

  static loadActiveContracts(filters) {
    let url = `${endpoints.BASE_URL}${endpoints.CONTRACTS}/active`;
    if (!isEmpty(filters)) {
      const params = `&${queryString.stringify(filters, {
        arrayFormat: "bracket"
      })}`;
      url = url.concat(`?${params}`);
    }

    return axios.get(url).then((response) => response.data);
  }
}

export default ContractService;
